import { render, staticRenderFns } from "./p_invest018.vue?vue&type=template&id=a19884b6&scoped=true&"
import script from "./p_invest018.vue?vue&type=script&lang=js&"
export * from "./p_invest018.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19884b6",
  null
  
)

export default component.exports